import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  // Tooltip,
} from "@chakra-ui/react";
import ServiceSelectNew from "../select/ServiceSelectNew";
import { useTranslation } from "react-i18next";
import {
  backgroundLight,
  newBorder,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { Flex, Icon, IconButton, Text } from "@chakra-ui/react";
import { FaXmark } from "react-icons/fa6";
import useIsMobile from "../../hooks/useIsMobile";

const AddServiceModal = ({
  addServiceModalOpen,
  setAddServiceModalOpen,
  addServiceToList,
  isAdvancedMode,
  toggleAdvancedMode,
  currency,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <>
      <Modal
        isOpen={addServiceModalOpen}
        onClose={() => setAddServiceModalOpen(false)}
        isCentered={!isMobile}
        autoFocus={false}
      >
        <ModalOverlay />
        <ModalContent
          borderRadius={{ base: "0", md: "1.5rem" }}
          w={{ base: "100%", md: "600px" }}
          minH={{ base: "100%", md: "auto" }}
          maxW="100vw"
          m={0}
          border={`1px solid ${newBorder}`}
        >
          <ModalHeader
            p="1.5rem 1.5rem"
            borderBottom={`1px solid ${newBorder}`}
          >
            <Flex w="100%" align="center" justify="space-between">
              <Text fontSize="1rem" fontWeight="600" color={textPrimary}>
                {/* {t("service.changePriceTitle")} */}
                {t("service.addService")}
              </Text>
              <Flex align="center" justify="flex-end" gap="1.5rem">
                {/* <Tooltip
                  p="0.5rem 1rem"
                  borderRadius="1rem"
                  placement="top"
                  closeOnClick={false}
                  label={
                    <Flex direction="column">
                      <Text fontSize="0.875rem" color={white} fontWeight="600">
                        {isAdvancedMode
                          ? t("service.advancedModeEnabled")
                          : t("service.advancedModeDisabled")}
                      </Text>

                      <Text fontSize="0.875rem" color={white} fontWeight="400">
                        {isAdvancedMode
                          ? t("service.advancedModeEnabledText")
                          : t("service.advancedModeDisabledText")}
                      </Text>
                    </Flex>
                  }
                >
                  <Button
                    size="sm"
                    maxW="2rem"
                    bg={isAdvancedMode ? primaryAlt : backgroundLight}
                    color={isAdvancedMode ? white : textSecondary}
                    onClick={toggleAdvancedMode}
                    borderRadius="10rem"
                    _hover={{
                      bg: isAdvancedMode ? primaryAlt : backgroundLight,
                      color: isAdvancedMode ? white : textSecondary,
                    }}
                  >
                    <Icon
                      as={isAdvancedMode ? FaLock : FaLockOpen}
                      fontSize="0.75rem"
                      pointerEvents="none"
                    />
                  </Button>
                </Tooltip> */}
                <IconButton
                  size="sm"
                  bg={backgroundLight}
                  color={textSecondary}
                  onClick={() => setAddServiceModalOpen(false)}
                  borderRadius="10rem"
                  _hover={{ bg: primaryAlt, color: white }}
                >
                  <Icon as={FaXmark} />
                </IconButton>
              </Flex>
            </Flex>
          </ModalHeader>

          <ModalBody p={["1.5rem 0rem 3rem", "1.5rem 1.5rem 3rem"]}>
            {/* <Button
              bg={isAdvancedMode ? primaryAlt : backgroundLight}
              onClick={toggleAdvancedMode}
            >
              {isAdvancedMode ? "Disable Advanced" : "Enable Advanced"}
            </Button> */}
            <Flex w="100%" p="0 0em">
              <ServiceSelectNew
                onChange={addServiceToList}
                isAdvancedMode={isAdvancedMode}
                toggleAdvancedMode={toggleAdvancedMode}
                currency={currency}
              />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddServiceModal;
